import React from 'react';
import './CandidatePreview.scss';
import CandidateTile from 'components/redesign/CandidateTile';
import CandidateDetail from 'pages/main/elections/candidate/CandidateDetail';
import { ICandidate, ICandidateForm } from 'store/reducers/elections/types';
import { IEmployee, IStudent } from 'store/reducers/user/types';
import { isStudent } from 'js/utils';

type Group = IStudent['group'];

const FALLBACK_GROUP: Group = {
    id: 0,
    name: '—',
    faculty: { id: 0, name: '—', short_name: '—' },
};

type ProfileFields = Pick<
    ICandidate,
    | 'first_name'
    | 'last_name'
    | 'middle_name'
    | 'age'
    | 'course'
    | 'student_number'
    | 'hostel'
    | 'group'
>;
function profileFields(user: IStudent | IEmployee | undefined): ProfileFields {
    if (user && isStudent(user)) {
        const {
            first_name,
            last_name,
            middle_name,
            age,
            course,
            student_number,
            hostel,
            group,
        } = user;
        return {
            first_name,
            last_name,
            middle_name,
            age,
            course,
            student_number,
            hostel,
            group,
        };
    }
    return {
        first_name: user ? user.first_name : 'Кандидат',
        last_name: user ? user.last_name : '',
        middle_name: user ? user.middle_name : '',
        age: 0,
        course: 0,
        student_number: 0,
        hostel: undefined,
        group: FALLBACK_GROUP,
    };
}
export function buildPreviewCandidate(
    form: ICandidateForm,
    pictureUrl: string,
    user: IStudent | IEmployee | undefined
): ICandidate {
    return {
        id: 0,
        ...profileFields(user),
        picture: pictureUrl,
        program_text: form.program_text,
        description_text: form.description_text,
        vk_nick: form.vk_nick,
        telegram_nick: form.telegram_nick,
    };
}

interface CandidatePreviewProps {
    candidate: ICandidate;
    editing: boolean;
    submitting: boolean;
    onBack: () => void;
    onSubmit: () => void;
}
function CandidatePreview({
    candidate,
    editing,
    submitting,
    onBack,
    onSubmit,
}: CandidatePreviewProps): React.ReactElement {
    let submitLabel = editing ? 'Сохранить изменения' : 'Отправить';
    if (submitting) submitLabel = editing ? 'Сохраняем…' : 'Отправляем…';

    return (
        <section className="rd-block rd-preview">
            <h1 className="rd-h1">Так тебя увидят</h1>
            <p className="rd-preview__hint">
                {editing
                    ? 'Проверь изменения перед сохранением.'
                    : 'Проверь анкету перед отправкой. Пока регистрация ' +
                      'открыта, её можно будет изменить.'}
            </p>

            <div className="rd-preview__tile">
                <CandidateTile
                    preview
                    data={{
                        id: candidate.id,
                        firstName: candidate.first_name,
                        lastName: candidate.last_name,
                        picture: candidate.picture,
                    }}
                />
            </div>

            <div className="rd-preview__card">
                <CandidateDetail candidate={candidate} />
            </div>

            <div className="rd-preview__actions">
                <button
                    type="button"
                    className="rd-btn rd-btn--plain"
                    onClick={onBack}
                    disabled={submitting}
                >
                    Исправить
                </button>
                <button
                    type="button"
                    className="rd-btn rd-btn--green"
                    onClick={onSubmit}
                    disabled={submitting}
                >
                    {submitLabel}
                </button>
            </div>
        </section>
    );
}

export default React.memo(CandidatePreview);
